import { observer } from "mobx-react";
import { useEstimateEditorSettings, useEstimateStructure } from "@tools";
import { SortableList } from "@components";
import Divider from "@material-ui/core/Divider";
import { PriceModifierRow } from "./BreakdownPriceRows/PriceModifierRow";
import { makeStyles } from "@material-ui/styles";
import { CELL_WIDTHS } from "@utils";

export const PriceModifierList = observer(() => {
  const { allowEdition, useProfitability } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  const classes = useStyle();
  
  const { visiblePriceModifiers } = structure;
  
  const handleReorder = (l) => {
    structure.reorderPriceModifiers(l)
  }
  return (
    <>
      <Divider className={ classes.divider } />
      <SortableList
        list={visiblePriceModifiers}
        path="priceModifiers"
        group="priceModifiers"
        onListReorder={handleReorder}
        displayAsColumnFlexbox
        disabled={!allowEdition || useProfitability}
      >
        {
          visiblePriceModifiers?.map((priceModifier, i) => (
            <PriceModifierRow
              key={`priceModifier${i}${priceModifier.id}`}
              priceModifier={priceModifier}
            />
          ))
        }
      </SortableList>
    </>
  );
});

const useStyle = makeStyles((theme) => ({
  divider: {
    backgroundColor: "transparent",
    backgroundImage: `linear-gradient(to right, ${theme.props.border} 50%, transparent 0%)`,
    backgroundPosition: "bottom",
    backgroundSize: "16px 1px",
    backgroundRepeat: "repeat-x",
    marginLeft: CELL_WIDTHS.DRAG_HANDLE,
    width: "initial",
    minWidth: `calc(100% - ${CELL_WIDTHS.DRAG_HANDLE}px)`,
    marginTop: 16,
    marginBottom: 16,
  }
}))

PriceModifierList.propTypes = {

};
